import classNames from 'classnames';
import type React from 'react';

export enum PaperShadows {
  sm = 'shadow-ds-sm',
  md = 'shadow-ds-md',
  lg = 'shadow-ds-lg',
}

export enum PaperPaddings {
  sm = 'p-3',
  md = 'p-4',
  lg = 'p-5',
  xl = 'p-6',
  xxl = 'p-7',
}

export enum PaperBorders {
  'ds-regular' = 'border border-ds-natural-150',
  'ds-dark' = 'border border-ds-natural-200',
}

export type PaperProps = {
  children: React.ReactNode;
  radius?: boolean;
  shadow?: keyof typeof PaperShadows;
  padding?: keyof typeof PaperPaddings;
  border?: keyof typeof PaperBorders | null;
  fillParent?: boolean;
};

export const Paper = ({
  children,
  radius,
  shadow,
  padding,
  border,
  fillParent,
}: PaperProps) => {
  return (
    <div
      className={classNames('bg-ds-accent3-100', {
        'rounded-lg': radius,
        [PaperBorders[border!]]: border,
        [PaperShadows[shadow!]]: shadow,
        [PaperPaddings[padding!]]: padding,
        'h-full w-full': fillParent,
      })}
    >
      {children}
    </div>
  );
};
